export const ru = {
    youHere: 'Вы здесь'
}